"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZodNever = void 0;
var ZodTypes_1 = require("../ZodTypes");
var base_1 = require("./base");
var ZodNever = (function (_super) {
    __extends(ZodNever, _super);
    function ZodNever() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.__class = "ZodNever";
        _this.toJSON = function () { return _this._def; };
        return _this;
    }
    ZodNever.create = function () {
        return new ZodNever({
            t: ZodTypes_1.ZodTypes.never,
        });
    };
    return ZodNever;
}(base_1.ZodType));
exports.ZodNever = ZodNever;
//# sourceMappingURL=never.js.map